import { filtersHelper } from '@/utils';

export const candidateStatusModel = (data) => ({
    uuid: data.uuid,
    name: data.name,
    description: data.description,
    sequence: data.sequence,
    emailSubject: data.email_subject,
    emailContent: data.email_content,
    emailCc: data.email_cc,
    isEmail: data.is_email,
    isInitial: data.is_initial,
    isCreateUser: data.is_create_user,
    isActive: data.is_active,
    createdAt: filtersHelper.getDateFormat(data.created_at),
    createdBy: data.created_by,
    updatedAt: filtersHelper.getDateFormat(data.updated_at),
    updatedBy: data.updated_by,
    deletedAt: filtersHelper.getDateFormat(data.deleted_at),
    deletedBy: data.deleted_by,
    candidateCount: data.candidates_count ? data.candidates_count : '0',
});
